import React from "react";
import T from "prop-types";
import cn from "classnames";

import BoxLabeled from "2g-box-labeled";

import useMessages from "./i18n/useMessages";
import FixniPozadavkyBoxObdobi from "./FixniPozadavkyBoxObdobi";

export function FixniPozadavkyBoxErrorContent({
  isError,
  loading,
  showObdobi = true,
  error,
  fazeObdobiFixni,
  fazeObdobiVsechny,
  faze
}) {
  const messages = useMessages();
  return isError ? (
    <BoxLabeled.Danger
      className={cn("b2b-FixniPozadavkyBoxErrorContent", {
        "is-closed": !faze?.fixni && !faze?.vsechny
      })}
      label={
        faze.fixni
          ? messages.titleErrorSmlouvaFixni()
          : messages.titleErrorClosed()
      }
    >
      {faze.fixni ? (
        messages.textErrorSmlouvaFixni()
      ) : showObdobi ? (
        <FixniPozadavkyBoxObdobi
          loading={loading}
          error={error}
          fazeObdobiFixni={fazeObdobiFixni}
          fazeObdobiVsechny={fazeObdobiVsechny}
          faze={faze}
        />
      ) : null}
    </BoxLabeled.Danger>
  ) : null;
}

FixniPozadavkyBoxErrorContent.propTypes = {
  isError: T.bool,
  loading: T.bool,
  showObdobi: T.bool,
  error: T.oneOfType([T.bool, T.string]),
  fazeObdobiFixni: T.object,
  fazeObdobiVsechny: T.object,
  faze: T.shape({ fixni: T.bool, vsechny: T.bool })
};

export default React.memo(FixniPozadavkyBoxErrorContent);
